import { defineMessages } from 'react-intl';

export default defineMessages({
    updateMedicalPackageTitle: {
        id: 'servicerequest.views.update.medicalpackage.title.Update Medical Package Title',
        defaultMessage: 'Update Medical Package'
    },
    medicalPackageField: {
        id: 'servicerequest.views.update.medicalpackage.field.New Medical Package',
        defaultMessage: 'New Medical Package'
    },
    cancel: {
        id: 'servicerequest.views.update.medicalpackage.button.Cancel',
        defaultMessage: 'Cancel'
    },
    send: {
        id: 'servicerequest.views.update.medicalpackage.button.Send',
        defaultMessage: 'Send'
    },
    pleaseSelect: {
        id: 'servicerequest.views.update.medicalpackage.field.Please Select',
        defaultMessage: 'Please Select'
    },
    error: {
        id: 'servicerequest.views.update.medicalpackage.Error',
        defaultMessage: 'Service Request update failed'
    },
    errorMessage: {
        id: 'servicerequest.views.update.medicalpackage.Error Message',
        defaultMessage: 'Sorry, we were unable to update the medical package'
    }
});
